// extracted by mini-css-extract-plugin
module.exports = {"button":"OneTrust_button__bGwGg"};